import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { XpressUserService } from 'app/services';
import {
    SpecialDiscountStatusEnum, SpecialDiscountTypeEnum,
    XpressUserProfile, XpressDeliveryPaymentMethodEnum
} from 'app/models';

enum ActionBtnEnum {
    None = 0,
    Add = 1,
    Update = 2,
    Remove = 3
}

@Component({
    selector: 'customer-manage-discount-dialog',
    templateUrl: './customer-manage-discount-dialog.component.html',
    styleUrls: ['./customer-manage-discount-dialog.component.scss',
        '../../../../../../styles/style-layout.scss'
    ],
    providers: [MessageService]
})

export class CustomerManageDiscountDialogComponent implements OnInit {
    public userId: number = 0;
    @Input()
    set _userId(value: number) {
        this.userId = value;
    }

    public specialDiscountStatus: SpecialDiscountStatusEnum = SpecialDiscountStatusEnum.None;
    @Input()
    set _specialDiscountStatus(value: SpecialDiscountStatusEnum) {
        this.specialDiscountStatus = value;
    }

    public specialDiscountType: SpecialDiscountTypeEnum = SpecialDiscountTypeEnum.None;
    @Input()
    set _specialDiscountType(value: SpecialDiscountTypeEnum) {
        this.specialDiscountType = value;
    }

    public visibleCustomerManageDiscountDialog: boolean = false;
    @Input()
    set _visibleCustomerManageDiscountDialog(value: boolean) {
        this.visibleCustomerManageDiscountDialog = value;
    }

    @Output() changedVisibleCustomerManageDiscountDialog = new EventEmitter<any>();

    public specialDiscountTypeEnum = SpecialDiscountTypeEnum;

    public specialDiscountStatusEnum = SpecialDiscountStatusEnum;

    public specialDiscountStatusList: any = XpressUserProfile.SpecialDiscountStatusList;

    public specialDiscountTypeList: any = XpressUserProfile.SpecialDiscountTypeList;

    public showSpinner: boolean = false;

    public visibleConfirmDialog: boolean = false;
    public actionBtnEnum = ActionBtnEnum;
    public activeActionConfirmBtn: ActionBtnEnum = ActionBtnEnum.None;
    public confirmBtnText: string = '';
    public specialDiscountRejectReason: string = '';

    constructor(private messageService: MessageService, private userService: XpressUserService) { }

    ngOnInit(): void {
        if (this.specialDiscountStatus === SpecialDiscountStatusEnum.None
            && this.specialDiscountType === SpecialDiscountTypeEnum.None) {
            this.activeActionConfirmBtn = ActionBtnEnum.Add;
        }
    }

    setSpecialDiscount() {
        if (this.specialDiscountStatus === SpecialDiscountStatusEnum.Rejected && !this.specialDiscountRejectReason) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please set reject reason' });
            return;
        }
        this.showSpinner = true;
        this.visibleConfirmDialog = false;

        this.specialDiscountType = this.activeActionConfirmBtn === ActionBtnEnum.Remove ? SpecialDiscountTypeEnum.None : this.specialDiscountType;
        this.specialDiscountStatus = this.activeActionConfirmBtn === ActionBtnEnum.Remove ? SpecialDiscountStatusEnum.None : this.specialDiscountStatus;

        const dto = {
            UserId: this.userId,
            SpecialDiscountType: this.specialDiscountType,
            SpecialDiscountStatus: this.specialDiscountStatus,
            RejectReason: this.specialDiscountRejectReason
        };

        this.userService.setSpecialDiscount(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.showSpinner = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                if (this.activeActionConfirmBtn === ActionBtnEnum.Add) {
                    if (this.specialDiscountStatus === SpecialDiscountStatusEnum.Rejected) {
                        this.messageService.add({
                            severity: 'error', summary: 'Special Discount Rejected',
                            detail: 'Discount successfully rejected. The user has been notified via email.'
                        });
                    } else {
                        this.messageService.add({
                            severity: 'success', summary: 'Special Discount Applied!',
                            detail: 'Discount successfully approved and applied. The user has been notified via email.'
                        });
                    }
                }
                else if (this.activeActionConfirmBtn === ActionBtnEnum.Update) {
                    if (this.specialDiscountStatus === SpecialDiscountStatusEnum.Rejected) {
                        this.messageService.add({
                            severity: 'error', summary: 'Special Discount Rejected',
                            detail: 'Discount successfully rejected. The user has been notified via email.'
                        });
                    } else {
                        this.messageService.add({
                            severity: 'success', summary: 'Special discount successfully updated',
                            detail: 'The previous discount has been replaced with the new details.'
                        });
                    }
                }
                else if (this.activeActionConfirmBtn === ActionBtnEnum.Remove) {
                    this.messageService.add({
                        severity: 'success', summary: 'Special discount removed successfully!',
                        detail: 'The discount has been deleted and will no longer be available for this user.'
                    });
                }

                this.cancel();
                this.showSpinner = false;
            })
            .catch(err => {
                this.showSpinner = false;
                throw err;
            });
    }

    cancel() {
        const obj = {
            visibleCustomerManageDiscountDialog: false,
            specialDiscountType: this.specialDiscountType,
            specialDiscountStatus: this.specialDiscountStatus
        };
        this.changedVisibleCustomerManageDiscountDialog.emit(obj);
    }

    openConfirmDialog(action: ActionBtnEnum) {
        this.visibleConfirmDialog = true;
        this.activeActionConfirmBtn = action;
        this.confirmBtnText = action === ActionBtnEnum.Remove ? 'Remove' : 'Yes, Overwrite';
    }
}
